export const LISTE_LOTS_COMPTABLE = {
  title: 'Lots comptables',
  racine: 'Accueil',
  actions: {
    search: 'Rechercher',
    filter: 'Filtre',
    transfere: 'Transférer',
    transfereTasser: 'Transférer en tassant les écritures',
  },
  tab: {
    libelle: 'Libellé',
    montant: 'Montant',
    creationTime: 'Crée le',
    etat: 'Etat',
    nbrEcritures: 'Nombre d’écritures',
    interfaceCompta: 'Interface comptable',
  },
  filtre: {
    etat: 'Etat du lot',
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
};

export const DETAIL_LOTS_COMPTABLE = {
  title: 'Détail lot',
  actions: {
    search: 'Rechercher',
    transfere: 'Transférer',
    transfereTasser: 'Transférer en tassant les écritures',
    annulerTransfert: 'Annluer transmission',
  },
  tab: {
    date: 'Date',
    libelle: 'Libellé',
    journal: 'Journal',
    lot: 'Lot',
    isValid: 'Etat',
  },
  etat: {
    valide: 'Valide',
    nonValide: 'Non valide',
  },
  steps: {
    creer: 'Créé',
    tranfere: 'Transféré',
  },
  msgError: {
    invalidAccounting: 'L\'une des écritures comptables n\'est pas valide. Le lot ne peut être exporté.',
    fileNotFound: 'Fichier d\'export n\'existe pas',
    ibizaError: 'L\'intégration du lot "{lotLibelle}" dans Ibiza n\'a pas abouti. \n Référence : {errorReference} \n Message : {errorMessage}',
  },
  msgSuccess: {
    nbrLot: 'élément(s) transféré(s)',
    fileTransmis: 'Élément(s) transféré(s)',
    annulation: 'Transmission annulée avec succès.',
  },
  information: {
    title: 'Informations',
    montant: 'Montant',
    dateTransfert: 'Date de transfert',
    nbEcritures: 'Nombre d\'écritures',
  },
  annulationTransfert: {
    title: 'Etes-vous sûr de vouloir annuler la transmission ?',
    warning: 'Attention, si vous retransferez ce lot plus tard, il sera en double dans votre comptabilité',
  },
};

export const SUPPRIMER_LOT = {
  irreversible: 'Cette action est irréversible.',
  delete: 'Etes-vous sûr de vouloir supprimer ce lot ?',
  deleteMultiple: 'Etes-vous sûr de vouloir supprimer ces lots ?',
  yes: 'Oui',
  no: 'Non',
  messages: {
    error: 'Suppression du lot impossible.',
    errorTransmis: 'Impossible de supprimer un lot transmis',
    deleteSuccess: 'La suppression à été réalisée avec succès',
  },
};
